export function generateUUID() {
  return crypto.randomUUID();
}
